<template>
    <div>
        <Header title="学生评教" type="0" route="/bk/xspj"></Header>
        <div v-if="list && list.length > 0" class="bkEvaluateItem">
            <div class="list-item info" v-for="(item, index) of list" :key="index">
                <p>{{ item.kcmc }}[{{ item.kch }}]</p>
                <ul>
                    <li>授课教师：{{ item.xm }}</li>
                    <li>评教类别：{{ item.pjdlmc }}</li>
                    <li>总评分：{{ item.zpf }}</li>
                    <li>已评：{{ item.issavestr }}</li>
                    <li>教师回复：{{ item.jyhfnr == '' ? '无' : item.jyhfnr }}</li>
                    <li>评价开始时间：{{ item.kssj }}</li>
                    <li>评价结束时间：{{ item.jssj }}</li>
                    <li v-if="item.sfbh == '1'" style="color:red">
                        未到评价时间，不能评价！
                    </li>
                </ul>
                <!-- <span v-if="item.sfbh == '1'" class="unClass">
                    评价
                </span> -->
                <span @click="goPj(item)">{{ item.sfbh === '1' ? '查看' : '评价' }}</span>
            </div>
        </div>
        <NOdata v-else title="暂无评价数据"></NOdata>
    </div>
</template>

<script>
import { Api } from '@/utils/axios';

export default {
    data() {
        return {
            list: [],
            params: {}
        };
    },
    created() {
        if (!!this.$route.query.params) {
            this.params = JSON.parse(this.$route.query.params);
        } else {
            this.params = {
                pj0502id: this.$route.query.list.pj0502id,
                pj05id: this.$route.query.list.pj05id,
                xnxq01id: this.$route.query.list.xnxq01id
            };
        }
        this.getList();
    },
    methods: {
        goPj(item) {
            this.$router.push({
                path: '/bk/pj',
                query: {
                    pj0502id: this.params.pj0502id,
                    jx02id: item.jx02id,
                    xnxq01id: this.params.xnxq01id,
                    jx0404id: item.jx0404id,
                    zpf: item.zpf,
                    pj01id: item.pj01id,
                    pj05id: item.pj05id,
                    issubmit: item.issubmit,
                    params: this.params
                }
            });
        },
        async getList() {
            const res = await Api.student_xspj_list(this.params);
            console.log('res:', res);
            if (typeof res.data != 'string') {
                this.list = res.data;
            }
        }
    }
};
</script>
<style lang="less" scoped>
.bkEvaluateItem {
    padding: 0 20px;
    .list-item {
        background: #f8f8f8;
        border-radius: 5px;
        margin: 0 auto 5%;
        padding: 3% 0 3% 6%;
        position: relative;
        p {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #212f6e;
            letter-spacing: 0;
            margin-bottom: 2%;
            font-weight: bold;
        }
        ul li {
            font-family: PingFangSC-Light;
            font-size: 12px;
            color: #757da3;
            letter-spacing: 0;
            margin-bottom: 1%;
        }
        span {
            width: 70px;
            height: 42px;
            background: #7469f8;
            border-radius: 3px;
            position: absolute;
            top: 40%;
            right: 3%;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #ffffff;
            letter-spacing: 0;
        }
        .unClass {
            background-color: #e5e5e5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/bkEvaluate/item.vue